export const APP_ICON_SERIES = [
  "original_navy",
  "midnight_blue",
  "deep_charcoal",
  "pos_slate",
  "original_navy_br",
  "midnight_blue_br",
  "deep_charcoal_br",
  "pos_slate_br",
];

const listeners = new Set();
const STORAGE_KEY = "nuageAppIconSeries";

function readSavedSeries() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return APP_ICON_SERIES.includes(saved) ? saved : "";
  } catch {
    return "";
  }
}

let currentSeries = readSavedSeries();
let started = false;

export function appIconUrl(series, size = 64) {
  if (!APP_ICON_SERIES.includes(series)) return "";
  const base = process.env.PUBLIC_URL || "";
  return `${base}/icon-series/${series}/${series}_${size}.png`;
}

export function subscribeAppIcon(listener) {
  listener(currentSeries);
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function publish(series) {
  currentSeries = APP_ICON_SERIES.includes(series) ? series : "";
  try {
    if (currentSeries) localStorage.setItem(STORAGE_KEY, currentSeries);
  } catch {
    // The icon still updates for this session.
  }
  listeners.forEach((listener) => listener(currentSeries));
  if (currentSeries) {
    const href = appIconUrl(currentSeries, 32);
    const links = document.querySelectorAll("link[rel='icon'], link[rel='alternate icon']");
    if (links.length === 0) {
      const link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png";
      link.href = href;
      document.head.appendChild(link);
      return;
    }
    links.forEach((link) => {
      link.type = "image/png";
      link.href = href;
    });
  }
}

export function startAppIconSync() {
  if (started) return;
  started = true;
  publish("midnight_blue_br");
}
